// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"545": "vendors","577": "__federation_expose_useHostAuthState",}[chunkId] || chunkId) + "-" + {"122": "2c7bfc488a4c79ca","48": "67dc51c02dea2423","545": "cb3630863bf2a624","577": "38ae27adb57ed741",}[chunkId] + ".bundle.js"
}